export const calculatePercentageChange = (currentValue, previousValue, decimalPlaces = 2) => {
    if (previousValue === 0) {
        return currentValue === 0 ? 0 : 100;
    }
    const result = ((currentValue - previousValue) / previousValue) * 100;
    return Number(result.toFixed(decimalPlaces));
};
export const calculateValuePercentageChange = (value) => calculatePercentageChange(value[0], value[1], 0);
